import { nextTick } from 'vue';
import { createRouter, createWebHistory } from 'vue-router'

const titleName = '群創職福會';
const routes = [
  {
    path: '/direct', meta: { subTitle: '自動導轉', layout: 'LoginLayout', anonymous: true },
    component: () => import('../views/Direct.vue'),
  },
  {
    path: '/login', meta: { subTitle: '登入', layout: 'LoginLayout', anonymous: true },
    component: () => import(/* webpackPrefetch: true */ '../views/employee/logIn.vue'),
  },
  {
    path: '/signup', meta: { subTitle: '註冊', layout: 'LoginLayout', anonymous: true },
    component: () => import(/* webpackPrefetch: true */ '../views/employee/signup.vue'),
  },
  {
    path: '/forgetPassword', meta: { subTitle: '忘記密碼', layout: 'LoginLayout', anonymous: true },
    component: () => import(/* webpackPrefetch: true */ '../views/employee/forgetPassword.vue')
  },
  {
    path: '/employee', meta: { nonEmp: true },
    children: [
      {
        path: 'maintain', meta: { subTitle: '個人資料維護', layout: 'Layout' },
        component: () => import(/* webpackPrefetch: true */ '../views/employee/maintain.vue'),
      },
      {
        path: 'modifyPassword', meta: { subTitle: '修改密碼' },
        component: () => import(/* webpackPrefetch: true */ '../views/employee/modifyPassword.vue'),
      },
    ]
  },
  {
    path: '/', layout: 'Layout',
    component: () => import(/* webpackPrefetch: true */ '../views/Index.vue')
  },
  {
    path: '/privacy', meta: { subTitle: '隱私權政策', layout: 'LoginLayout', anonymous: true },
    component: () => import('../views/privacy.vue'),
  },
  {
    path: '/news', meta: { subTitle: '新聞', },
    component: () => import(/* webpackPrefetch: true */ '../views/News.vue')
  },
  {
    path: '/info', meta: { subTitle: '職福資訊' },
    children: [
      {
        path: 'news',
        component: () => import(/* webpackPrefetch: true */ '../views/News.vue'),
        meta: { subTitle: '公告訊息' }
      },
      {
        path: 'members',
        component: () => import(/* webpackPrefetch: true */ '../views/Members.vue'),
        meta: { subTitle: '職福會資訊', }
      }
      ,
      {
        path: 'minutes',
        component: () => import(/* webpackPrefetch: true */ '../views/Minutes.vue'),
        meta: { subTitle: '會議記錄', }
      }
    ]
  },
  {
    path: '/allowance', meta: { subTitle: '福利津貼', },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackPrefetch: true */ '../views/Allowance.vue'),
        meta: { subTitle: '申請津貼', }
      },
      {
        path: 'record',
        component: () => import(/* webpackPrefetch: true */ '../views/allowance_record.vue'),
        meta: { subTitle: '申請紀錄', }
      },
    ]
  },
  {
    path: '/service', meta: { subTitle: '按摩小站', },
    children: [
      {
        path: 'reserve',
        component: () => import(/* webpackPrefetch: true */ '../views/service_reserve.vue'),
        meta: { subTitle: '預約按摩', }
      },
      {
        path: 'record',
        component: () => import(/* webpackPrefetch: true */ '../views/service_record.vue'),
        meta: { subTitle: '按摩紀錄', }
      },
      {
        path: 'submit',
        component: () => import(/* webpackPrefetch: true */ '../views/service_submit.vue'),
        meta: { subTitle: '預約按摩', }
      }
    ]
  },
  {
    path: '/activity', meta: { subTitle: '活動報名', nonEmp: true },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackPrefetch: true */ '../views/activity/activity.vue'),
        meta: { subTitle: '近期活動', }
      },
      {
        path: 'registered',
        component: () => import(/* webpackPrefetch: true */ '../views/activity/activity_registered.vue'),
        meta: { subTitle: '已報名活動', }
      },
      {
        path: 'detail',
        component: () => import(/* webpackPrefetch: true */ '../views/activity/activity_detail.vue'),
        meta: { subTitle: '活動說明', },
      },
      {
        path: 'registeredDetail',
        component: () => import(/* webpackPrefetch: true */ '../views/activity/activity_detail_registered.vue'),
        meta: { subTitle: '已報名活動', }
      },
      {
        path: 'apply',
        component: () => import(/* webpackPrefetch: true */ '../views/activity/activity_apply.vue'),
        meta: { subTitle: '報名活動', }
      }
    ]
  },
  {
    path: '/club', meta: { subTitle: '社團活動', },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackPrefetch: true */ '../views/club/club.vue'),
        meta: { subTitle: '社團活動', }
      },
      {
        path: 'myclub',
        component: () => import(/* webpackPrefetch: true */ '../views/club/myclub.vue'),
        meta: { subTitle: '我的社團', }
      },
      {
        path: 'event',
        component: () => import(/* webpackPrefetch: true */ '../views/club/club_event.vue'),
        meta: { subTitle: '我的社團', }
      },
      {
        path: 'detail',
        component: () => import(/* webpackPrefetch: true */ '../views/club/club_detail.vue'),
        meta: { subTitle: '我的社團', }
      },
      {
        path: 'apply',
        component: () => import(/* webpackPrefetch: true */ '../views/club/club_apply.vue'),
        meta: { subTitle: '我的社團', }
      },
      {
        path: 'album',
        component: () => import(/* webpackPrefetch: true */ '../views/club/club_album.vue'),
        meta: { subTitle: '我的社團', }
      },
    ]
  },
  {
    path: '/CheckInQRCode', meta: { subTitle: '活動QRCode' },
    component: () => import(/* webpackPrefetch: true */ '../views/CheckInQRCode.vue'),
  },
  {
    path: '/store', meta: { subTitle: '特約商店', legal: ['啟耀'] },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackPrefetch: true */ '../views/store/index.vue'),
        meta: { subTitle: '瀏覽特約商店', legal: ['啟耀'] },
      },
      {
        path: 'category',
        component: () => import(/* webpackPrefetch: true */ '../views/store/category.vue'),
        meta: { subTitle: '瀏覽特約商店', legal: ['啟耀'] },
      },
      {
        path: 'detail',
        component: () => import(/* webpackPrefetch: true */ '../views/store/detail.vue'),
        meta: { subTitle: '瀏覽特約商店', legal: ['啟耀'] },
      },
      {
        path: 'news',
        component: () => import(/* webpackPrefetch: true */ '../views/store/news.vue'),
        meta: { subTitle: '公告訊息', },
      },
      {
        path: 'search',
        component: () => import(/* webpackPrefetch: true */ '../views/store/search.vue'),
        meta: { subTitle: '熱門特約商店', }
      },
      {
        path: 'choice',
        component: () => import(/* webpackPrefetch: true */ '../views/store/choice.vue'),
        meta: { subTitle: '嚴選網站', legal: ['啟耀'] },
      },
      {
        path: 'promot',
        component: () => import(/* webpackPrefetch: true */ '../views/store/promot.vue'),
        meta: { subTitle: '我要推薦', }
      },
      {
        path: 'promotRecord',
        component: () => import(/* webpackPrefetch: true */ '../views/store/promotRecord.vue'),
        meta: { subTitle: '推薦紀錄', }
      }
    ]
  },
  {
    path: '/questionnaire', meta: { subTitle: '問卷調查' },
    component: () => import('../views/questionnaire.vue'),
  },
  {
    path: '/invalid', meta: { subTitle: '無權限', legal: ['啟耀'] },
    component: () => import(/* webpackPrefetch: true */ '../views/invalid.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (from.path === to.path) {
      return false;
    }
    return { top: 0 };
  }
})

router.beforeEach((to, from, next) => {
  let fullTitle = titleName;
  if (to.meta.subTitle != null) { fullTitle = `${to.meta.subTitle} - ${titleName}` }
  document.title = fullTitle;

  const anonymous = to.matched.some(record => record.meta.anonymous);
  if (anonymous) { next(); }
  else {
    const loginInfo = JSON.parse(localStorage.getItem('LoginInfo'));
    if (!loginInfo) { next('/login'); }

    if (loginInfo.corporationName == '啟耀') {
      const pass = to.matched.some(record => record.meta.legal?.includes('啟耀'));

      if (pass) { next(); }
      else { next('/invalid'); }
    }
    else if (loginInfo.isEmp) { next(); }
    else {
      //非會員
      const nonEmp = to.matched.some(record => record.meta.nonEmp);

      if (nonEmp) { next(); }
      else { next('/activity/index'); }
    }
    next('/login');
  }
})

router.afterEach((to, from) => {
  nextTick(() => {
    let wrapper = document.querySelector('#wrapper');

    if (wrapper) {
      wrapper.classList.remove('allowancePage', 'servicePage', 'activityPage', 'storePage');

      if (to.path.startsWith('/allowance')) { wrapper.classList.add('allowancePage') }
      if (to.path.startsWith('/service')) { wrapper.classList.add('servicePage') }
      if (to.path.startsWith('/activity') || to.path.startsWith('/club')) { wrapper.classList.add('activityPage') }
      if (to.path.startsWith('/store')) { wrapper.classList.add('storePage') }
    }
  });
});



export default router